<template>
	<div class="input-amount inactive" @click.capture.stop="focusInput">
		<div>
			<span v-if="value">{{value | format-currency(currency)}}</span>
		</div>
		<div>
			<input type="number" v-bind:value="value" @focus="onInputFocus"
			       @blur="onInputBlur" @input="onInput" required
			       class="form-control" step="any" :disabled="disabled"/>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			value: Number,
			currency: String,
			disabled: Boolean
		},

		methods: {
			focusInput() {
				if (!this.disabled) {
					$(this.$el).find('input').focus();
				}
			},
			onInput(event) {
				this.$emit('input', event.target.value || 0);
			},
			onInputFocus() {
				var $input = $(this.$el).removeClass('inactive', true).find('input');
				setTimeout(() => { $input.select() });
			},
			onInputBlur() {
				$(this.$el).toggleClass('inactive', true);
			}
		}
	}
</script>

<style lang="scss">
	.input-amount {
		> div:first-child {
			display: none;
		}
		input {
			color: inherit;
		}
	    &.inactive {
			> div:first-child {
				display: block;
				position: absolute;
				line-height: 1.25rem;
				padding: 0.5rem 0 0.5rem 0.25rem;
			}
			input {
			    color: transparent;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/ui/widgets/input-amout.vue